import { AFbLink } from 'components/FbUI/FbLink/styles'

interface Info {
  getValue: () => string | undefined
}

type IconComponent = React.ComponentType<{ size?: number; className?: string }>

export const LinkCell = ({
  info,
  icon: Icon,
  label = 'View',
}: {
  info: Info
  /** Optional leading icon — e.g. PiMapPin for Place URL cells. */
  icon?: IconComponent
  /** Override the default "View" label. */
  label?: string
}) => {
  return info.getValue() ? (
    <AFbLink href={info.getValue()} target="_blank">
      <span className="inline-flex items-center gap-1">
        {Icon ? <Icon size={16} /> : null}
        {label}
      </span>
    </AFbLink>
  ) : (
    <>-</>
  )
}
